import { render, staticRenderFns } from "./pan.vue?vue&type=template&id=56a5d23f&scoped=true&"
import script from "./pan.vue?vue&type=script&lang=js&"
export * from "./pan.vue?vue&type=script&lang=js&"
import style0 from "./pan.vue?vue&type=style&index=0&id=56a5d23f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a5d23f",
  null
  
)

export default component.exports